import React, { useState } from "react";
import { Eye, EyeOff, Check, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { passwordChecks } from "@/lib/securityApi";
import { useST } from "@/i18n/securityText";

const BAR = ["bg-red-500", "bg-orange-400", "bg-amber-400", "bg-venka-green", "bg-venka-green"];

/** Password input with show/hide; with `meter`, shows the strength bar and the rules the server enforces. */
export const PasswordField = ({ value, onChange, label, meter = false, email = "", autoComplete = "new-password", testid, className = "" }) => {
  const { st } = useST();
  const [show, setShow] = useState(false);
  const { checks, score } = passwordChecks(value, email);
  return (
    <label className={`block ${className}`}>
      {label && <span className="text-xs font-medium text-slate-400">{label}</span>}
      <div className="relative mt-1.5">
        <Input type={show ? "text" : "password"} value={value} onChange={(e) => onChange(e.target.value)} autoComplete={autoComplete}
          className="h-10 pr-10 bg-slate-950 border-slate-700" data-testid={testid} />
        <button type="button" tabIndex={-1} onClick={() => setShow(!show)} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-slate-500 hover:text-slate-300" aria-label="Show password">
          {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </div>
      {meter && value && (
        <div className="mt-2 space-y-1.5">
          <div className="flex items-center gap-2">
            <div className="flex flex-1 gap-1">{[0, 1, 2, 3].map((i) => <span key={i} className={`h-1.5 flex-1 rounded-full ${i < score ? BAR[score] : "bg-slate-700"}`} />)}</div>
            <span className="text-[11px] text-slate-400 w-20 text-right">{st("strength")[score]}</span>
          </div>
          <ul className="grid gap-0.5 text-[11px]">
            {[["length", "rLength"], ["letters", "rLetters"], ["noEmail", "rEmail"]].map(([k, l]) => (
              <li key={k} className={`flex items-center gap-1.5 ${checks[k] ? "text-venka-green" : "text-slate-500"}`}>
                {checks[k] ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />}{st(l)}
              </li>
            ))}
          </ul>
        </div>
      )}
    </label>
  );
};

export default PasswordField;
